var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":_vm.$t('page not found'),"back-link":_vm.$t('back')}}),_vm._v(" "),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('page not found')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }